export default "__VITE_ASSET__ZQvZ97RT__"